<ng-container *ngIf="{
row: columnData | async
} as $">
    <p-tag styleClass="mr-3 surface-500 text-900 text-xxs font-normal uppercase white-space-nowrap">{{$.row.deposit_name}}</p-tag>
    <span>{{'DEPOSIT.'+$.row.occurence_type | translate}}</span>
</ng-container>